import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Heading, VStack } from '@chakra-ui/react';

import { Page } from '../../../../types';
import { SignUpForm } from './Form';
import { StoreData } from './Form/store';
import { axiosWrapper } from '../../../../hooks/axios';
import { AuthContext } from '../../../../context/AuthProvider';

const SignUpPage: Page = () => {
  const user = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [error, setError] = useState<string>();
  const [usernameError, setUsernameError] = useState<string>();
  const [emailError, setEmailError] = useState<string>();


  const onSubmit = async (data: StoreData) => {
    try {
      const res = await axiosWrapper<{ ok: boolean }>(
        `/api/v1/user/register/`,
        'post',
        JSON.stringify(data),
      );
      if (res.data.ok) {
        window.location.href = '/';
      }
    } catch (err) {
      console.log("error: ", (err as any).response.data.error);
      switch ((err as any).response.status) {
        case 400:
          if ((err as any).response.data.error.includes('Email')) {
            return setEmailError((err as any).response.data.error);
          }
          return setUsernameError((err as any).response.data.error || 'Something went wrong');
        case 404:
          return setError(
            (err as any)?.response?.data?.error || 'Class not found',
          );
        case 409:
          return setUsernameError((err as any).response.data.error);
        default:
          console.error(err, (err as any).status);
      }
    }
  };



  useEffect(() => {
    if (user?.is_authenticated) {
      navigate('/', { replace: true });
    }
  }, [navigate, user]);

  return (
    <VStack
      spacing={0}
      gap={4}
      align="center"
      justify="center"
      minH="calc(100vh - 60px - 88px)"
      padding={4}
    >
      <Heading as="h3" size="xl" color="blue.500" mb={4} textAlign="center">
        {t("signUp.signUp")}
      </Heading>
      {error && (
        <Heading as="h4" size="lg" color="crimson">
          {error}
        </Heading>
      )}
      <SignUpForm
        w="full"
        maxW="500px"
        mb={8}
        onSubmit={onSubmit}
        usernameError={usernameError}
        emailError={emailError}
      />
      {/* <OAuthOptions description="Other join options" /> */}
    </VStack>
  );
};

SignUpPage.getRoute = () => '/sign-up';

export default SignUpPage;
